export const darkModePalette = {
  mode: "dark",
  background: {
    default: "#22242b",
  },
};
